// Random stock-market artwork shown when a news article has no usable picture
// and we have no company icon/logo for the ticker.
//
// TO ADD MORE: drop the image into frontend/public/news-fallback/ (jpg, ~16:9,
// non-copyright) and add its path to this list. Nothing else to change.
export const NEWS_FALLBACK_IMAGES = [
  '/news-fallback/market-1.jpg',   // original blue trading-floor artwork
  '/news-fallback/market-2.jpg',
  '/news-fallback/market-3.jpg',
  '/news-fallback/market-4.jpg',
  '/news-fallback/market-5.jpg',   // News-1: hooded trader, neon screens
  '/news-fallback/market-6.jpg',   // News-2: dual monitors, office
  '/news-fallback/market-7.jpg',   // News-3: blue bar chart
  '/news-fallback/market-8.jpg',   // News-4: bull vs bear, globe
  '/news-fallback/market-9.jpg',   // News-5: INVEST blocks, coins
  '/news-fallback/market-10.jpg',  // News-6: NYSE facade, US flag
  '/news-fallback/market-11.jpg',  // News-7: Wall St / Broadway sign
  '/news-fallback/market-12.jpg',  // News-8: analyst at dual screens
  '/news-fallback/market-13.jpg',  // News-9: trading floor, STOCK screen
  '/news-fallback/market-14.jpg',  // News-10: STOCK MARKET infographic
  '/news-fallback/market-15.jpg',  // News-11: data-center server racks
  '/news-fallback/market-16.jpg',  // News-12
  '/news-fallback/market-17.jpg',  // News-13
  '/news-fallback/market-18.jpg',  // News-14
  '/news-fallback/market-19.jpg',  // set 1: phone chart, coffee, leaves
  '/news-fallback/market-20.jpg',  // set 1: analysts pointing at printed chart
  '/news-fallback/market-21.jpg',  // set 1: trading patterns clipboard, phone
  '/news-fallback/market-22.jpg',  // set 1: TRADING scrabble tiles
  '/news-fallback/market-23.jpg',  // set 1: kanban tablet over trading screens
  '/news-fallback/market-24.jpg',  // set 2: STOCK MARKET desk, calculator, cash
  '/news-fallback/market-25.jpg',  // set 2: NEWS wood frame on black marble
  '/news-fallback/market-26.jpg',  // set 2: NEWS UPDATE scrabble tiles
  '/news-fallback/market-27.jpg',  // set 2: LATEST NEWS wooden blocks
  '/news-fallback/market-28.jpg',  // set 2: NYSE facade close-up
  '/news-fallback/market-29.jpg',  // set 3: phone candlestick chart on cash
  '/news-fallback/market-30.jpg',  // set 3: AAPL phone chart on newspaper tables
  '/news-fallback/market-31.jpg',  // set 3: laptop, BUSINESS paper, glasses, coffee
  '/news-fallback/market-32.jpg',  // set 3: glowing multi-chart trading screen
  '/news-fallback/market-33.jpg',  // set 3: teal circuit-board bokeh
  '/news-fallback/market-34.jpg',  // set 4: orange/blue glowing candlestick grid
  '/news-fallback/market-35.jpg',  // set 4: "Market Movers News" dual monitors
  '/news-fallback/market-36.jpg',  // set 4: world map with regional up/down arrows
];

// Finnhub hands us Yahoo's generic "Yahoo! Finance" brand image for most Yahoo
// syndicated stories — it's not a photo of anything, so treat it like "no image".
const YAHOO_PLACEHOLDER_RE = /(s\.yimg\.com\/rz\/stage\/p\/yahoo_finance|s\.yimg\.com\/cv\/apiv2\/social|yahoo_default_logo|yahoo_finance_logo|yahoo_finance_en-US)/i;
export function isYahooPlaceholder(url) {
  return !!url && YAHOO_PLACEHOLDER_RE.test(String(url));
}

// Deterministic pick (same article → same picture across re-renders/scrolls),
// but different articles spread evenly across the pool.
export function pickFallbackImage(seed, pool = NEWS_FALLBACK_IMAGES) {
  if (!pool.length) return null;
  const s = String(seed || '');
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return pool[h % pool.length];
}
